import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getBrowserLang } from '../util';
import i18nSeismicCDN from './getSeismicCDNPlugin';
import enUS from './en-US.json';

i18n
    .use(i18nSeismicCDN)
    .use(initReactI18next)
    .init({
        resources: {
            'en-US': {
                translation: enUS
            }
        },
        partialBundledLanguages: true, // allows some resources to be set on initialization while others can be loaded using a backend connector
        backend: {
            loadPath: '/static/seismic-i18n/LiveSendViewer/Default/{{lng}}.json',
            allowMultiLoading: false,
            crossDomain: true
        },
        debug: true,
        fallbackLng: 'en-US',
        load: 'currentOnly',
        keySeparator: false,
        react: {
            useSuspense: true
        }
    });

export default i18n;

export const getLang = () => {
    let lang = getBrowserLang();
    const languageList = ['en-US', 'en-GB', 'de-DE', 'es-ES', 'fr-FR', 'fr-CA', 'it-IT', 'ja-JP', 'ko-KR', 'pt-BR', 'zh-CN', 'zh-TW', 'ru-RU', 'id-ID', 'tr-TR',
        'ar-XM', 'bg-BG', 'hr-HR', 'cs-CZ', 'da-DK', 'et-EE', 'fi-FI', 'el-GR', 'hu-HU', 'lt-LT', 'pl-PL', 'ro-RO', 'sk-SK', 'sv-SE', 'nl-NL'];
    if (!new Set(languageList).has(lang)) {
        lang = languageList.find(l => l.toLowerCase() === lang.toLowerCase() ||
            l.split('-')[0].toLowerCase() === lang.toLowerCase() ||
            l.split('-')[0].toLowerCase() === lang.split('-')[0].toLowerCase());
    }

    return lang || 'en-US';
};
